export default __webpack_public_path__ + "static/media/Sleeve-dresse.8f0036fe.jpg";